import { render, staticRenderFns } from "./OfferCreateForm.vue?vue&type=template&id=4c8a965a"
import script from "./OfferCreateForm.vue?vue&type=script&lang=js"
export * from "./OfferCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports